import React, { useState } from 'react';
import {
    GiftCard,
    GiftCardPayment,
    i18nFn,
    observer,
    useSpringBigStore,
    useUpdateGiftCard
} from '@springbig/shared';
import { Box, HStack, Switch, VStack } from 'native-base';
import { Caption, CaptionError } from '~/shared/Typography';
import AmountDropdown from './dropdowns/Amount';
import PaymentDropdown from './dropdowns/Payment';
import { useGeneralStyles } from '~/shared/styles';
import { useToast } from '~/hooks/toast';
import Button from '~/shared/Button';
import ButtonSpinner from '~/shared/ButtonSpinner';
import { useEffectOnce } from 'usehooks-ts';

const ManageAutoReload = ({ manageGiftCard, t }: { manageGiftCard: GiftCard | null, t: i18nFn }) => {

    const gStyle = useGeneralStyles();
    const [isAutoReloadOn, setIsAutoReloadOn] = useState(manageGiftCard?.auto_reload || false);
    const [belowAmount, setbelowAmount] = useState<number>(parseFloat(manageGiftCard.auto_reload_amount?.split('$')[1]));
    const [amount, setAmount] = useState<number>(Number(manageGiftCard.auto_reload_balance?.toString().slice(0, -2)));
    const [paymentMethod, setPaymentMethod] = useState<GiftCardPayment | null>(null);
    const { member, giftCardPaymentList } = useSpringBigStore();
    const { successToast } = useToast();
    const { mutate: updateGiftCard, isLoading, error: requestGiftCardUpdateError } = useUpdateGiftCard();

    const isSubmitEnabled = member && member.id && member.merchant_id && !isLoading;

    const onAutoReloadUpdate = () => {

        updateGiftCard({

            id: manageGiftCard.id,
            member_id: member.id,
            auto_reload: isAutoReloadOn,
            auto_reload_balance: amount,
            auto_reload_amount: belowAmount,
            gift_card_payment_id: paymentMethod?.id,
        }, {
            onSuccess: (_) => {

                observer.emit('close-actionsheet');
                successToast(t('giftCard.addFunds.reloadSuccess'));
            },
        });
    };

    useEffectOnce(() => {

        if (manageGiftCard && giftCardPaymentList) {
            setPaymentMethod(giftCardPaymentList.find(p => p.id === manageGiftCard.gift_card_payment_id) as GiftCardPayment);
        }
    });

    return (
        <Box width='100%' alignItems='center' >
            <VStack width='100%' space={4} flexGrow={1}>
                <Caption fontSize={24} textAlign={'center'}>
                    { t('giftCard.addFunds.autoReload.title') }
                </Caption>
                <HStack justifyContent="space-between">
                    <Caption fontSize={18} fontWeight={300}>
                        { t('giftCard.addFunds.autoReload.subTitle') }
                    </Caption>
                    <Switch
                        onTrackColor={gStyle.button_background}
                        // onThumbColor={gStyle.button_background}
                        // offTrackColor={gStyle.divider}
                        isChecked={isAutoReloadOn}
                        onToggle={() => setIsAutoReloadOn(prev => !prev)}
                    />
                </HStack>
                <VStack>
                    <Caption fontSize={18} fontWeight={300}>
                        { t('giftCard.addFunds.autoReload.belowbalance') }
                    </Caption>
                    <AmountDropdown
                        t={t}
                        amount={belowAmount}
                        setAmount={setbelowAmount}
                    />
                </VStack>
                <VStack>
                    <Caption fontSize={18} fontWeight={300}>
                        { t('giftCard.addFunds.autoReload.amount') }
                    </Caption>
                    <AmountDropdown
                        t={t}
                        amount={amount}
                        setAmount={setAmount}
                    />
                </VStack>
                <VStack>
                    <Caption fontSize={18} fontWeight={300}>{ t('giftCard.addFunds.autoReload.payment') }</Caption>
                    <PaymentDropdown
                        paymentMethod={paymentMethod}
                        setPaymentMethod={setPaymentMethod}
                        t={t}
                    />
                </VStack>
                {member?.customer_gift_card_fee && member?.customer_gift_card_fee !== '$0.00' &&
                    <Caption textAlign='center'>
                        { t('giftCard.addFunds.conditions.fees', [member?.customer_gift_card_fee]) }
                    </Caption>
                }
                { requestGiftCardUpdateError &&
                    <CaptionError>
                        {(requestGiftCardUpdateError as any)?.data?.error}
                    </CaptionError>
                }
                <Button
                    onPress={onAutoReloadUpdate}
                    backgroundColor={gStyle.button_background}
                    borderRadius={10}
                    isDisabled={!isSubmitEnabled}
                    width='55%'
                    alignSelf={'center'}
                >
                    { isLoading ?
                        <ButtonSpinner />
                        :
                        <Caption color={gStyle.button_text} fontSize={20}>
                            { t('general.save') }
                        </Caption>
                    }
                </Button>
            </VStack>
        </Box>
    );
};

export default ManageAutoReload;
